export const MANUAL_AUTOFINALIZE_REQUEST = 'MANUAL_AUTOFINALIZE_REQUEST';
export const MANUAL_AUTOFINALIZE_SUCCESS = 'MANUAL_AUTOFINALIZE_SUCCESS';
export const MANUAL_AUTOFINALIZE_FAILURE = 'MANUAL_AUTOFINALIZE_FAILURE';

export const REMOVE_AUDIT_REASONS_REQUEST = 'REMOVE_AUDIT_REASONS_REQUEST';
export const REMOVE_AUDIT_REASONS_SUCCESS = 'REMOVE_AUDIT_REASONS_SUCCESS';
export const REMOVE_AUDIT_REASONS_FAILURE = 'REMOVE_AUDIT_REASONS_FAILURE';

export const GET_AFFECTED_ENCOUNTERS_REQUEST = 'GET_AFFECTED_ENCOUNTERS_REQUEST';
export const GET_AFFECTED_ENCOUNTERS_SUCCESS = 'GET_AFFECTED_ENCOUNTERS_SUCCESS';
export const GET_AFFECTED_ENCOUNTERS_FAILURE = 'GET_AFFECTED_ENCOUNTERS_FAILURE';

export const ENABLE_CC_AUDIT_REQUEST = 'ENABLE_CC_AUDIT_REQUEST';
export const ENABLE_CC_AUDIT_SUCCESS = 'ENABLE_CC_AUDIT_SUCCESS';
export const ENABLE_CC_AUDIT_FAILURE = 'ENABLE_CC_AUDIT_FAILURE';

export const DISABLE_CC_AUDIT_REQUEST = 'DISABLE_CC_AUDIT_REQUEST';
export const DISABLE_CC_AUDIT_SUCCESS = 'DISABLE_CC_AUDIT_SUCCESS';
export const DISABLE_CC_AUDIT_FAILURE = 'DISABLE_CC_AUDIT_FAILURE';

export const PLACE_CC_ON_AUDIT_REQUEST = 'PLACE_CC_ON_AUDIT_REQUEST';
export const PLACE_CC_ON_AUDIT_SUCCESS = 'PLACE_CC_ON_AUDIT_SUCCESS';
export const PLACE_CC_ON_AUDIT_FAILURE = 'PLACE_CC_ON_AUDIT_FAILURE';

export const REMOVE_CC_FROM_AUDIT_REQUEST = 'REMOVE_CC_FROM_AUDIT_REQUEST';
export const REMOVE_CC_FROM_AUDIT_SUCCESS = 'REMOVE_CC_FROM_AUDIT_SUCCESS';
export const REMOVE_CC_FROM_AUDIT_FAILURE = 'REMOVE_CC_FROM_AUDIT_FAILURE';

export const ENABLE_DX_AUDIT_REQUEST = 'ENABLE_DX_AUDIT_REQUEST';
export const ENABLE_DX_AUDIT_SUCCESS = 'ENABLE_DX_AUDIT_SUCCESS';
export const ENABLE_DX_AUDIT_FAILURE = 'ENABLE_DX_AUDIT_FAILURE';

export const DISABLE_DX_AUDIT_REQUEST = 'DISABLE_DX_AUDIT_REQUEST';
export const DISABLE_DX_AUDIT_SUCCESS = 'DISABLE_DX_AUDIT_SUCCESS';
export const DISABLE_DX_AUDIT_FAILURE = 'DISABLE_DX_AUDIT_FAILURE';

export const PLACE_DX_ON_AUDIT_REQUEST = 'PLACE_DX_ON_AUDIT_REQUEST';
export const PLACE_DX_ON_AUDIT_SUCCESS = 'PLACE_DX_ON_AUDIT_SUCCESS';
export const PLACE_DX_ON_AUDIT_FAILURE = 'PLACE_DX_ON_AUDIT_FAILURE';

export const REMOVE_DX_FROM_AUDIT_REQUEST = 'REMOVE_DX_FROM_AUDIT_REQUEST';
export const REMOVE_DX_FROM_AUDIT_SUCCESS = 'REMOVE_DX_FROM_AUDIT_SUCCESS';
export const REMOVE_DX_FROM_AUDIT_FAILURE = 'REMOVE_DX_FROM_AUDIT_FAILURE';

export const ENABLE_CODER_AUDIT_REQUEST = 'ENABLE_CODER_AUDIT_REQUEST';
export const ENABLE_CODER_AUDIT_SUCCESS = 'ENABLE_CODER_AUDIT_SUCCESS';
export const ENABLE_CODER_AUDIT_FAILURE = 'ENABLE_CODER_AUDIT_FAILURE';

export const DISABLE_CODER_AUDIT_REQUEST = 'DISABLE_CODER_AUDIT_REQUEST';
export const DISABLE_CODER_AUDIT_SUCCESS = 'DISABLE_CODER_AUDIT_SUCCESS';
export const DISABLE_CODER_AUDIT_FAILURE = 'DISABLE_CODER_AUDIT_FAILURE';

export const PLACE_CODER_ON_AUDIT_REQUEST = 'PLACE_CODER_ON_AUDIT_REQUEST';
export const PLACE_CODER_ON_AUDIT_SUCCESS = 'PLACE_CODER_ON_AUDIT_SUCCESS';
export const PLACE_CODER_ON_AUDIT_FAILURE = 'PLACE_CODER_ON_AUDIT_FAILURE';

export const REMOVE_CODER_FROM_AUDIT_REQUEST = 'REMOVE_CODER_FROM_AUDIT_REQUEST';
export const REMOVE_CODER_FROM_AUDIT_SUCCESS = 'REMOVE_CODER_FROM_AUDIT_SUCCESS';
export const REMOVE_CODER_FROM_AUDIT_FAILURE = 'REMOVE_CODER_FROM_AUDIT_FAILURE';

export const ENABLE_NEW_HCC_AUDIT_REQUEST = 'ENABLE_NEW_HCC_AUDIT_REQUEST';
export const ENABLE_NEW_HCC_AUDIT_SUCCESS = 'ENABLE_NEW_HCC_AUDIT_SUCCESS';
export const ENABLE_NEW_HCC_AUDIT_FAILURE = 'ENABLE_NEW_HCC_AUDIT_FAILURE';

export const DISABLE_NEW_HCC_AUDIT_REQUEST = 'DISABLE_NEW_HCC_AUDIT_REQUEST';
export const DISABLE_NEW_HCC_AUDIT_SUCCESS = 'DISABLE_NEW_HCC_AUDIT_SUCCESS';
export const DISABLE_NEW_HCC_AUDIT_FAILURE = 'DISABLE_NEW_HCC_AUDIT_FAILURE';

export const ENABLE_AUTO_EXPORT_REQUEST = 'ENABLE_AUTO_EXPORT_REQUEST';
export const ENABLE_AUTO_EXPORT_SUCCESS = 'ENABLE_AUTO_EXPORT_SUCCESS';
export const ENABLE_AUTO_EXPORT_FAILURE = 'ENABLE_AUTO_EXPORT_FAILURE';

export const DISABLE_AUTO_EXPORT_REQUEST = 'DISABLE_AUTO_EXPORT_REQUEST';
export const DISABLE_AUTO_EXPORT_SUCCESS = 'DISABLE_AUTO_EXPORT_SUCCESS';
export const DISABLE_AUTO_EXPORT_FAILURE = 'DISABLE_AUTO_EXPORT_FAILURE';

export const ENABLE_PURGE_DURING_NEXT_READ_REQUEST =
  'ENABLE_PURGE_DURING_NEXT_READ_REQUEST';
export const ENABLE_PURGE_DURING_NEXT_READ_SUCCESS =
  'ENABLE_PURGE_DURING_NEXT_READ_SUCCESS';
export const ENABLE_PURGE_DURING_NEXT_READ_FAILURE =
  'ENABLE_PURGE_DURING_NEXT_READ_FAILURE';

export const DISABLE_PURGE_DURING_NEXT_READ_REQUEST =
  'DISABLE_PURGE_DURING_NEXT_READ_REQUEST';
export const DISABLE_PURGE_DURING_NEXT_READ_SUCCESS =
  'DISABLE_PURGE_DURING_NEXT_READ_SUCCESS';
export const DISABLE_PURGE_DURING_NEXT_READ_FAILURE =
  'DISABLE_PURGE_DURING_NEXT_READ_FAILURE';

export const ENABLE_DOC_PROC_AUTOFINALIZE_REQUEST =
  'ENABLE_DOC_PROC_AUTOFINALIZE_REQUEST';
export const ENABLE_DOC_PROC_AUTOFINALIZE_SUCCESS =
  'ENABLE_DOC_PROC_AUTOFINALIZE_SUCCESS';
export const ENABLE_DOC_PROC_AUTOFINALIZE_FAILURE =
  'ENABLE_DOC_PROC_AUTOFINALIZE_FAILURE';

export const DISABLE_DOC_PROC_AUTOFINALIZE_REQUEST =
  'DISABLE_DOC_PROC_AUTOFINALIZE_REQUEST';
export const DISABLE_DOC_PROC_AUTOFINALIZE_SUCCESS =
  'DISABLE_DOC_PROC_AUTOFINALIZE_SUCCESS';
export const DISABLE_DOC_PROC_AUTOFINALIZE_FAILURE =
  'DISABLE_DOC_PROC_AUTOFINALIZE_FAILURE';

export const ENABLE_UNVALIDATED_DX_AUDIT_REQUEST =
  'ENABLE_UNVALIDATED_DX_AUDIT_REQUEST';
export const ENABLE_UNVALIDATED_DX_AUDIT_SUCCESS =
  'ENABLE_UNVALIDATED_DX_AUDIT_SUCCESS';
export const ENABLE_UNVALIDATED_DX_AUDIT_FAILURE =
  'ENABLE_UNVALIDATED_DX_AUDIT_FAILURE';

export const DISABLE_UNVALIDATED_DX_AUDIT_REQUEST =
  'DISABLE_UNVALIDATED_DX_AUDIT_REQUEST';
export const DISABLE_UNVALIDATED_DX_AUDIT_SUCCESS =
  'DISABLE_UNVALIDATED_DX_AUDIT_SUCCESS';
export const DISABLE_UNVALIDATED_DX_AUDIT_FAILURE =
  'DISABLE_UNVALIDATED_DX_AUDIT_FAILURE';

export const ENABLE_CCC_NEW_DX_AUDIT_REQUEST = 'ENABLE_CCC_NEW_DX_AUDIT_REQUEST';
export const ENABLE_CCC_NEW_DX_AUDIT_SUCCESS = 'ENABLE_CCC_NEW_DX_AUDIT_SUCCESS';
export const ENABLE_CCC_NEW_DX_AUDIT_FAILURE = 'ENABLE_CCC_NEW_DX_AUDIT_FAILURE';

export const DISABLE_CCC_NEW_DX_AUDIT_REQUEST = 'DISABLE_CCC_NEW_DX_AUDIT_REQUEST';
export const DISABLE_CCC_NEW_DX_AUDIT_SUCCESS = 'DISABLE_CCC_NEW_DX_AUDIT_SUCCESS';
export const DISABLE_CCC_NEW_DX_AUDIT_FAILURE = 'DISABLE_CCC_NEW_DX_AUDIT_FAILURE';

export const ENABLE_CCC_UNVALIDATED_DX_AUDIT_REQUEST =
  'ENABLE_CCC_UNVALIDATED_DX_AUDIT_REQUEST';
export const ENABLE_CCC_UNVALIDATED_DX_AUDIT_SUCCESS =
  'ENABLE_CCC_UNVALIDATED_DX_AUDIT_SUCCESS';
export const ENABLE_CCC_UNVALIDATED_DX_AUDIT_FAILURE =
  'ENABLE_CCC_UNVALIDATED_DX_AUDIT_FAILURE';

export const DISABLE_CCC_UNVALIDATED_DX_AUDIT_REQUEST =
  'DISABLE_CCC_UNVALIDATED_DX_AUDIT_REQUEST';
export const DISABLE_CCC_UNVALIDATED_DX_AUDIT_SUCCESS =
  'DISABLE_CCC_UNVALIDATED_DX_AUDIT_SUCCESS';
export const DISABLE_CCC_UNVALIDATED_DX_AUDIT_FAILURE =
  'DISABLE_CCC_UNVALIDATED_DX_AUDIT_FAILURE';

export const ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST =
  'ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST';
export const ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS =
  'ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS';
export const ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE =
  'ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE';

export const DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST =
  'DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST';
export const DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS =
  'DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS';
export const DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE =
  'DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE';

export const HYDRATE = 'HYDRATE';

export const PURGE_REQUEST = 'PURGE_REQUEST';
export const PURGE_SUCCESS = 'PURGE_SUCCESS';
export const PURGE_FAILURE = 'PURGE_FAILURE';

export const PRIORITY_WORKBY_REQUEST = 'PRIORITY_WORKBY_REQUEST';
export const PRIORITY_WORKBY_SUCCESS = 'PRIORITY_WORKBY_SUCCESS';
export const PRIORITY_WORKBY_FAILURE = 'PRIORITY_WORKBY_FAILURE';

export const PRIORITY_STRATEGY_REQUEST = 'PRIORITY_STRATEGY_REQUEST';
export const PRIORITY_STRATEGY_SUCCESS = 'PRIORITY_STRATEGY_SUCCESS';
export const PRIORITY_STRATEGY_FAILURE = 'PRIORITY_STRATEGY_FAILURE';

export const ENABLE_ENCOUNTER_AUTO_REREAD_REQUEST = 'ENABLE_ENCOUNTER_AUTO_REREAD_REQUEST';
export const ENABLE_ENCOUNTER_AUTO_REREAD_SUCCESS = 'ENABLE_ENCOUNTER_AUTO_REREAD_SUCCESS';
export const ENABLE_ENCOUNTER_AUTO_REREAD_ERROR = 'ENABLE_ENCOUNTER_AUTO_REREAD_ERROR';

export const DISABLE_ENCOUNTER_AUTO_REREAD_REQUEST = 'DISABLE_ENCOUNTER_AUTO_REREAD_REQUEST';
export const DISABLE_ENCOUNTER_AUTO_REREAD_SUCCESS = 'DISABLE_ENCOUNTER_AUTO_REREAD_SUCCESS';
export const DISABLE_ENCOUNTER_AUTO_REREAD_ERROR = 'DISABLE_ENCOUNTER_AUTO_REREAD_ERROR';

export const ENABLE_CLIENT_REVIEW_REQUEST = 'ENABLE_CLIENT_REVIEW_REQUEST';
export const ENABLE_CLIENT_REVIEW_SUCCESS = 'ENABLE_CLIENT_REVIEW_SUCCESS';
export const ENABLE_CLIENT_REVIEW_FAILURE = 'ENABLE_CLIENT_REVIEW_FAILURE';

export const DISABLE_CLIENT_REVIEW_REQUEST = 'DISABLE_CLIENT_REVIEW_REQUEST';
export const DISABLE_CLIENT_REVIEW_SUCCESS = 'DISABLE_CLIENT_REVIEW_SUCCESS';
export const DISABLE_CLIENT_REVIEW_FAILURE = 'DISABLE_CLIENT_REVIEW_FAILURE';
